import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { BehaviorComponent } from "./behavior/behavior.component";
import { EntityFilterComponent } from "./entity-filter/entity-filter.component";
import { EventPriorityComponent } from "./event-priority/event-priority.component";
import { FailoverComponent } from "./failover/failover.component";
import { GeneralComponent } from "./general/general.component";
import { LogsComponent } from "./logs/logs.component";
import { MicrosoftTeamsComponent } from "./microsoft-teams/microsoft-teams.component";
import { NotificationsComponent } from "./notifications/notifications.component";
import { SecurityRoleFilterComponent } from "./security-role-filter/security-role-filter.component";
import { SettingsComponent } from "./settings.component";

const routes: Routes = [
  {
    path: "",
    component: SettingsComponent,
    children: [
      {
        path: "",
        redirectTo: "general",
        pathMatch: "full"
      },
      {
        path: "general",
        component: GeneralComponent
      },
      {
        path: "behavior",
        component: BehaviorComponent
      },
      {
        path: "microsoft-teams",
        component: MicrosoftTeamsComponent
      },
      {
        path: "event-priority",
        component: EventPriorityComponent
      },
      {
        path: "entity-filter",
        component: EntityFilterComponent
      },
      {
        path: "security-role-filter",
        component: SecurityRoleFilterComponent
      },
      {
        path: "logs",
        component: LogsComponent
      },
      {
        path: "notifications",
        component: NotificationsComponent
      },
      {
        path: "failover",
        component: FailoverComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SettingsRoutingModule {}
